<template>
<div class="chapter">
<div class="inner_page">
<h1 class="project-title">CONTENTS</h1>
<p class="toc-text1"><a href="#/Introduction">Introduction</a></p>
<p class="toc-text1"><a href="#/Chapter1">Scrapflower Quilt</a></p>
<p class="toc-text1"><a href="#/Chapter2">Scrapflower Pillows</a></p>
<p class="toc-text1"><a href="#/Chapter3">Vintage Teapot Quilt</a></p>
<p class="toc-text1"><span href="#/Chapter4" title="Link target outside of Sample">Birdhouse Quilt</span></p>
<p class="toc-text1"><span href="#/Chapter5" title="Link target outside of Sample">Fan Flower Quilt</span></p>
<p class="toc-text1"><span href="#/Chapter6" title="Link target outside of Sample">Four Block Quilt</span></p>
<p class="toc-text1"><span href="#/Chapter7" title="Link target outside of Sample">Four Block Pillow</span></p>
<p class="toc-text1"><span href="#/Chapter8" title="Link target outside of Sample">Cat and Bird Quilt</span></p>
<p class="toc-text1"><span href="#/Chapter9" title="Link target outside of Sample">Cat and Bird Pillow</span></p>
<p class="toc-text1"><span href="#/Chapter10" title="Link target outside of Sample">Cross Quilt</span></p>
<p class="toc-text1"><span href="#/Chapter11" title="Link target outside of Sample">Plaid Quilt</span></p>
<p class="toc-text1"><span href="#/Chapter12" title="Link target outside of Sample">Duck Quilt</span></p>
<p class="toc-text1"><span href="#/Chapter13" title="Link target outside of Sample">Plum Party Quilt</span></p>
<p class="toc-text1"><span href="#/Chapter14" title="Link target outside of Sample">Cosy Stripe Quilt</span></p>
<p class="toc-text1"><span href="#/Chapter14#C14-2" title="Link target outside of Sample">Cosy Stripe Pillow</span></p>
<p class="toc-text1"><span href="#/Chapter15" title="Link target outside of Sample">Plum Garden Village Quilt</span></p>
<p class="toc-text1"><span href="#/Chapter16" title="Link target outside of Sample">Plum Village Pillow</span></p>
<p class="toc-text1"><span href="#/Chapter17" title="Link target outside of Sample">Plum Quilt</span></p>
<p class="toc-text1"><span href="#/Chapter18" title="Link target outside of Sample">Happy Snowman Quilt</span></p>
<p class="toc-text1"><span href="#/Chapter19" title="Link target outside of Sample">Happy Snowman Pillow</span></p>
<p class="toc-text1"><span href="#/Materials" title="Link target outside of Sample">Materials</span></p>
<p class="toc-text1"><span href="#/Techniques" title="Link target outside of Sample">Basic Techniques</span></p>
<p class="toc-text1"><span href="#/Patterns" title="Link target outside of Sample">Patterns</span></p>
<p class="toc-text1"><span href="#/Suppliers" title="Link target outside of Sample">Suppliers</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0cc6f165